import React from 'react';
import { Link } from 'react-router-dom';
import { Target, Zap, BarChart3 } from 'lucide-react';

// LV1 Method steps - updated copy
const methodSteps = [
  {
    number: '01',
    title: 'Strategic Branding',
    description: 'We follow a selective brand acceptance approach, focusing on brands we believe can win globally. Every brand we work with is expected to show strong digital presence, clear identity, and consistent storytelling. Across our portfolio, our brands reach millions of people through social and retail touchpoints.',
    icon: <Target size={22} strokeWidth={1.5} />,
  },
  {
    number: '02',
    title: 'Fashion',
    description: 'Trends move fast and retailers need answers fast. Our team tracks market shifts across regions and turns ideas into production-ready product quickly. Smart inventory positioning and fast development help our partners stay reactive, build stronger assortments, and plan the next season with confidence.',
    icon: <Zap size={22} strokeWidth={1.5} />,
  },
  {
    number: '03',
    title: 'Analytics',
    description: 'Our internal feedback loop blends market reads, consumer response, and retail performance signals. We use that input to refine silhouettes, update color and material direction, and focus on what actually sells. The result is clearer decisions, tighter assortments, and better outcomes at scale.',
    icon: <BarChart3 size={22} strokeWidth={1.5} />,
  },
];

const Process = () => {
  return (
    <section id="method" className="bg-[#0a0a0a] py-20 px-6">
      <div className="max-w-[1320px] mx-auto">
        {/* Section Header */}
        <div className="text-center mb-14">
          <p className="text-[#6a6a6a] text-[13px] mb-3 uppercase tracking-wider">How we work</p>
          <h2 className="text-[42px] md:text-[52px] font-extralight text-white mb-4 tracking-[-0.02em]">
            Our Method
          </h2>
          <p className="text-[#8a8a8a] text-[15px] leading-[1.7] max-w-[550px] mx-auto mb-8">
            Delivering footwear through strategic branding, fast development, and data-driven decisions.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/contact"
              className="px-7 py-3.5 bg-white text-[#0a0a0a] rounded-full text-[15px] font-medium hover:bg-white/90 transition-all duration-300 text-center"
            >
              Partner With Us
            </Link>
            <Link
              to="/about"
              className="px-7 py-3.5 border border-white/20 text-white rounded-full text-[15px] font-medium hover:bg-white/5 hover:border-white/30 transition-all duration-300 text-center"
            >
              Learn More About Us
            </Link>
          </div>
        </div>

        {/* Method Steps - Three Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {methodSteps.map((step) => (
            <div
              key={step.number}
              className="p-8 rounded-[24px] transition-all duration-300 group hover:-translate-y-1"
              style={{
                backdropFilter: 'blur(2px)',
                WebkitBackdropFilter: 'blur(2px)',
                backgroundColor: 'rgba(255, 255, 255, 0.02)',
                boxShadow: `inset 0 0 20px rgba(255,255,255,0.05),
                           inset 0 1px 1px rgba(255,255,255,0.1),
                           0px 4px 20px rgba(0,0,0,0.12)`,
                borderTop: '1px solid rgba(255,255,255,0.15)',
                borderLeft: '1px solid rgba(255,255,255,0.1)',
                borderRight: '1px solid rgba(255,255,255,0.05)',
                borderBottom: '1px solid rgba(255,255,255,0.03)',
              }}
            >
              {/* Step number */}
              <div className="flex items-center justify-between mb-6">
                <div className="text-white/80">
                  {step.icon}
                </div>
                <span className="text-[13px] text-white/30 font-medium">
                  {step.number}
                </span>
              </div>

              <h3 className="text-[20px] text-white font-medium mb-4">
                {step.title}
              </h3>
              <p className="text-[#8a8a8a] text-[14px] leading-[1.7]">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
